<template>
  <Header ref="header"/>
  <router-view @is-logged-in="userLogin()"/>
  <Footer/>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import {ref} from "vue";

export default {
  name: 'App',
  components: {
    Header, Footer
  },
  setup() {
    const header = ref(null);
    const userLogin = () => {
      header.value?.checkUserLogged();
    }

    return {
      userLogin,
      header
    }
  }
}
</script>

<style scoped>
</style>
